export default __webpack_public_path__ + "static/media/choose_project_icon.e68b0e93.png";